import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'lib-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss']
})
export class VideoPlayerComponent implements OnInit {
  private apiLoaded = false;

  @Input() videoId: any = null;
  @Input() start: any = 0;

  constructor() {
  }

  ngOnInit(): void {
    if (!this.apiLoaded) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api?howinfo=0&controls=0&color=white';
      document.body.appendChild(tag);
      this.apiLoaded = true;
    }
  }

}
